import homeFeature1 from "../assets/HomeFeature_1.avif";
import homeFeature2 from "../assets/HomeFeature_2.avif";
import homeFeature3 from "../assets/HomeFeature_3.avif";
import homeFeature4 from "../assets/HomeFeature_4.avif";
import contentImg from "../assets/content.png";
import canva from "../assets/integration/Canva.avif";
import salesforce from "../assets/integration/Salesforce.avif";
import instagram from "../assets/integration/Instagram.avif";
import shopify from "../assets/integration/Shopify.avif";
import google_Analytics from "../assets/integration/Google_Analytics.avif";
import wooCommerce from "../assets/integration/WooCommerce.avif";
import quickBooks from "../assets/integration/Quickbooks.avif";
import zapier from "../assets/integration/Zapier.avif";
import squareSpace from "../assets/integration/Squarespace.avif";

export const navLinks = [
  {
    id: 1,
    title: "Solutions and Services",
    url: "/",
  },
  {
    id: 2,
    title: "Resources",
    url: "/",
  },
  {
    id: 3,
    title: "Switch to Mailchimp",
    url: "/",
  },
  {
    id: 4,
    title: "Pricing",
    url: "/",
  },
];

export const features = [
  {
    id: 1,
    title: "Convert with email automations",
    imgSrc: homeFeature1,
    desc: "Boost orders and customer lifetime value by dynamically personalizing emails based on browsing and purchase data.",
    btnText: "Explore marketing automation",
    bgColor: "bg-[#e7b75f]",
  },
  {
    id: 2,
    title: "Create faster withgenerative AI",
    imgSrc: homeFeature2,
    desc: "Effortlessly create on-brand content with generative AI tools and choose from expertly designed templates.",
    btnText: "Explore AI tools",
    bgColor: "bg-gray-100",
  },
  {
    id: 3,
    title: "Refine with segmentation",
    imgSrc: homeFeature3,
    desc: "Target customers with advanced logic like spend amounts, buying behavior, and predicted attributes.",
    btnText: "Explore audience management",
    bgColor: "bg-[#e7b75f]",
  },
  {
    id: 4,
    title: "Optimize with analytics & reporting",
    imgSrc: homeFeature4,
    desc: "Analyze performance with custom reports, funnel visualizations, and industry benchmarking.",
    btnText: "Explore analytics & reporting",
    bgColor: "bg-gray-100",
  },
];

export const content = [
  {
    id: 1,
    title: "Content Optimizer",
    desc: "Learn how your emails compare to the top-performing campaigns in your industry and get data-driven suggestions for improving your copy, imagery, and layout.",
    img: contentImg,
  },
  {
    id: 2,
    title: "Creative Assistant",
    desc: "Our Creative Assistant will help you stand out by using AI to create custom designs for your brand.",
    img: contentImg,
  },
  {
    id: 3,
    title: "GDPR ready tools",
    desc: "Mailchimp helps you achieve data security and privacy standards for your customers.",
    img: contentImg,
  },
];

export const integrations = [
  {
    id: 1,
    title: "Canva",
    desc: "Create compelling visuals for your marketing.",
    img: canva,
    url: "/",
  },
  {
    id: 2,
    title: "Mailchimp for Salesforce",
    desc: "Sync your Mailchimp subscribers and Salesforce leads across paltforms.",
    img: salesforce,
    url: "/",
  },
  {
    id: 3,
    title: "Instagram",
    desc: "Promote and share your instagram posts in email campaigns.",
    img: instagram,
    url: "/",
  },
  {
    id: 4,
    title: "Shopify",
    desc: "Sync Shopify customers, products, and purchase data to Mailchimp.",
    img: shopify,
    url: "/",
  },
  {
    id: 5,
    title: "Google Analytics",
    desc: "Unlock powerful insights with campaign, website, or landing page data.",
    img: google_Analytics,
    url: "/",
  },
  {
    id: 6,
    title: "WooCommerce",
    desc: "Power your ecommerce store with smart marketing features.",
    img: wooCommerce,
    url: "/",
  },
  {
    id: 7,
    title: "QuickBooks Online",
    desc: "Bring together your marketing tools and invoice data.",
    img: quickBooks,
    url: "/",
  },
  {
    id: 8,
    title: "Squarespace Commerce",
    desc: "Market your ecommerce business and drive sales.",
    img: squareSpace,
    url: "/",
  },
  {
    id: 9,
    title: "Zapier",
    desc: "Automatically pass data between web services without a single line of code.",
    img: zapier,
    url: "/",
  },
];

export const disclaimers = [
  {
    id: 1,
    text: "Availability of features and functionality varies by plan type. For details, view plans and pricing.",
  },
  {
    id: 2,
    text: "Core marketing functionality has been translated to Spanish, French, German, Italian and Portuguese. Certain features, functionality and messaging within the Mailchimp app are not translated. Mailchimp users must be logged into their account to update language preferences.",
  },
  {
    id: 3,
    text: "Intuit Assist functionality (beta) is available to certain users with Premium, Standard and Legacy plans in select countries in English only. Access to Intuit Assist is available at no additional cost at this time. Pricing, terms, conditions, special features and service options are subject to change without notice. Availability of features and functionality varies by plan type. Features may be broadly available soon but represents no obligation and should not be relied on in making a purchasing decision. For details, please view Mailchimp’s various plans and pricing.",
  },
  {
    id: 4,
    text: `Generate up to 4X more orders with Customer Journey Builder automations based on orders generated through user's connected stores with automations versus when they used bulk emails.`,
  },
  {
    id: 5,
    text: "Get up to 88% more revenue based on emails sent with predicted segments against non-predictive segmented emails for users with connected stores only. Standard or Premium Plans only.",
  },
  {
    id: 6,
    text: "This information contains forward-looking statements, including our expectations regarding the functionality and availability of current or future features. Because these forward-looking statements involve risks and uncertainties, there are important factors that could cause our actual results to differ materially from these expectations, as described in our SEC filings. This represents no obligation to deliver future features and should not be relied on in making a purchasing decision. Additional terms, conditions, and fees may apply.",
  },
  {
    id: 7,
    text: "Email Content Generator available to select US Standard and Premium plan users.",
  },
];

export const footerLinks = [
  {
    title: "Products",
    links: [
      "Why Mailchimp?",
      "Product Updates",
      "Email Marketing",
      "Websites",
      "Transactional Email",
      "How We Compare",
      "GDPR Compliance",
      "Security",
      "Status",
      "Mobile App",
    ],
  },
  {
    title: "Resources",
    links: [
      "Marketing Library",
      "Free Marketing Tools",
      "Marketing Glossary",
      "Integrations Directory",
    ],
  },
  {
    title: "Community",
    links: ["Agencies & Freelancers", "Developers", "Events"],
  },
  {
    title: "Company",
    links: [
      "Our Story",
      "Newsroom",
      "Give Where You Live",
      "Careers",
      "Accessibility",
    ],
  },
  {
    title: "Help",
    links: ["Contact Us", "Hire an Expert", "Help Center", "Talk to Sales"],
  },
];
